module.exports = __webpack_public_path__ + "media/images/pla/pla7-9773fc6e45e0d49484cf1d5d2c9ed524.jpg";